import React, {useState } from 'react'
import { Modal, Col, Row, Label, Button} from 'reactstrap'
import { Form } from 'react-final-form'
import CloseIcon from 'mdi-react/CloseIcon'
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon'
import {flashDispatch, flashMessage } from '@/shared/helpers'
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage"
import axios from 'axios'
import TemplateButton from "@/shared/components/TemplateButton"

const ChangeStatusModal = ({isOpen, setOpen, toggle, participants, program, organization, name}) => {
  const dispatch = flashDispatch()
  const [saving, setSaving] = useState(false);
  let statusLabel,status = '';
  if(name == "Deactivate") {
    statusLabel = 'Deactivated'; status= 'Deactivated';
  }
  if(name == "Activate") {
    statusLabel = 'Activated'; status= 'Active';
  }
  if(name == "Lock") {
    statusLabel = 'Locked'; status= 'Locked';
  }
  if(name == "Unlock") {
    statusLabel = 'Active'; status= 'Active';
  }

  const onSubmit = values => {
    // console.log(JSON.stringify( values ))
    var formData = {
      users: [],
      'status': status
    }

    participants.map((item, index) => {
      formData.users.push(item.id)
    })
    // console.log(formData)
    // setSaving(true)
    // return

    axios
    .patch(`/organization/${organization.id}/program/${program.id}/participant/status`, formData)
    .then((res) => {
        // console.log(res)
      if (res.status == 200) {
        dispatch(flashMessage(`Participants ${statusLabel.toLowerCase()} successfully!`, 'alert-success', 'top'))
        setSaving(false)
        toggle()
        window.location.reload()
      }
    })
    .catch((err) => {
      //console.log(error.response.data);
      dispatch(flashMessage(<ApiErrorMessage errors={err.response.data} />, 'alert-danger', 'top'))
      setSaving(false)
    });

    console.log(formData)
  }

  let initialValues = {
  }

  return (
    <Modal className={`program-settings padded`} isOpen={isOpen} toggle={() => setOpen(true)}>
          <div
            className='close cursor-pointer d-flex align-items-center justify-content-center'
            style={{ border: '1px solid #ced4da', borderRadius: '4px', width: '28px', height: '28px' }}
            onClick={toggle}
          >
            <CloseIcon size={18}/>
          </div>
          <div className="container" style={{ padding: '1.25rem 1.5rem 1.5rem' }}>
            <div className='title mt-0 mb-1'>
              <h5 style={{ fontSize: '1.1rem', margin: 0 }}>{name} user</h5>
            </div>
            {saving && 'Processing, please wait...'}
            <Form
              onSubmit={onSubmit}
              initialValues={initialValues}
              validate={validate}
            >
              {({ handleSubmit, form, submitting, pristine, values }) => {
                // console.log(values)
                return (
                <form className="form d-flex flex-column justify-content-evenly" onSubmit={handleSubmit}>
                  <>
                    {name === "Deactivate" && (
                      <Row className="mb-3">
                        <Col md="12">
                          <div
                            className="alert alert-danger mb-0 d-flex align-items-start gap-2"
                            role="alert"
                            style={{ border: '1px solid #954543', color: '#954543', fontSize: '0.9rem', padding: '0.85rem 1rem' }}
                          >
                            <AlertCircleOutlineIcon size={18} className="flex-shrink-0" />
                            <span>Are you sure you want to deactivate? Awards are not returned to the property account when deactivated.</span>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Col md="12">
                        <div
                          className="rounded d-flex justify-content-between align-items-center flex-wrap gap-2"
                          style={{ border: '1px solid #ced4da', fontSize: '0.9rem', padding: '0.85rem 1rem' }}
                        >
                          <Label className="mb-0">Participant list to be {statusLabel.toLowerCase()}</Label>
                          <div className="text-end">
                            {participants.map((item, index) => {
                              return <div key={index}>
                                <strong>{item.name}</strong>
                              </div>
                            })}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className='d-flex justify-content-end gap-2'>
                      <Button
                        color="secondary"
                        outline
                        type='button'
                        onClick={toggle}
                        className="mb-0"
                        style={{ padding: '0.35rem 0.9rem', borderRadius: '8px', fontSize: '0.85rem' }}
                      >
                        Cancel
                      </Button>
                      <TemplateButton className="px-3 py-1 small mb-0" disabled={saving} type='submit' text={name} />
                    </div>
                  </>
                </form>
              )}}
            </Form>
          </div>
    </Modal>
)}

const validate = () => {
  let errors = {
  }
  return errors
}

export default ChangeStatusModal;
